import { render, staticRenderFns } from "./id-new.vue?vue&type=template&id=2b3de080"
import script from "./id-new.vue?vue&type=script&lang=ts"
export * from "./id-new.vue?vue&type=script&lang=ts"
import style0 from "./id-new.vue?vue&type=style&index=0&id=2b3de080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports